import { render, staticRenderFns } from "./in-app-browser-modal.vue?vue&type=template&id=1ed6b96c&"
import script from "./in-app-browser-modal.vue?vue&type=script&lang=js&"
export * from "./in-app-browser-modal.vue?vue&type=script&lang=js&"
import style0 from "./in-app-browser-modal.vue?vue&type=style&index=0&id=1ed6b96c&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports